import { SegmentEffects } from './segment.effects';

export const segmentEffects = [SegmentEffects];
